import {
    Heading,
    Skeleton,
    Stack,
    Text,
    ThemeBorderVariable,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeRadiusVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";
import { useWebBooking } from "api/api-hooks/use-web-booking";
import { useTranslation } from "react-i18next";

export function WaitListStartTimes() {
    const { data: reservation } = useWebBooking();
    const { t } = useTranslation();

    const border = `${ThemeBorderVariable.XSmall} ${ThemeColorVariable.OnSurfaceBorder}`;
    if (!reservation?.articles || !reservation?.nonTableArticles) {
        return (
            <Stack>
                <Skeleton height="22px" w="40%" />
                <Skeleton height="58px" w="full" />
            </Stack>
        );
    }
    const webRuleTitle = reservation.webBookingRules?.at(0)?.title?.toLocaleLowerCase();
    const isWaitList = reservation.isWaitList();
    return (
        <Stack>
            <Heading as="h4" fontWeight={"medium"} fontSize={ThemeFontSizeVariable.Large}>
                {isWaitList
                    ? t("waitList.timesWithWaitListForX", {
                          ruleName: webRuleTitle,
                      })
                    : t("myBooking.title")}
            </Heading>
            <Stack
                border={border}
                borderRadius={ThemeRadiusVariable.Small}
                p={ThemeSpaceVariable.Medium}
            >
                <Stack spacing={ThemeSpaceVariable.XSmall} direction="row" flexWrap="wrap">
                    {reservation?.articles.map((article, index) => (
                        <Text key={index}>
                            {article.start.format("HH:mm")}
                            {index !== reservation.articles.length - 1 && ","}
                        </Text>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    );
}
